import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {delay, shareReplay, debounceTime} from 'rxjs/operators';

/**
 * Emits layout size change events to coordinate responsive UI adjustments.
 */
@Injectable()
export class LayoutService {

  /** Internal subject broadcasting layout size changes. */
  protected layoutSize$ = new Subject();
  /** Shared observable stream for layout size changes. */
  protected layoutSizeChange$ = this.layoutSize$.pipe(
    shareReplay({refCount: true}),
  );

  /** Triggers a layout size change notification. */
  changeLayoutSize() {
    this.layoutSize$.next(null);
  }

  /** Emits layout change events with a minimal delay for stability. */
  onChangeLayoutSize(): Observable<any> {
    return this.layoutSizeChange$.pipe(delay(1));
  }

  /** Emits debounced layout change events for safe reactive handling. */
  onSafeChangeLayoutSize(): Observable<any> {
    return this.layoutSizeChange$.pipe(
      debounceTime(350),
    );
  }
}
